import React from "react";

export function WB_CoreHeaderThree({}) {
    return <div className="prose prose-base">
        <h3>Header Three</h3>
    </div>
}